module.exports = __webpack_public_path__ + "static/RootSans-4LightItalic-45310746654895951a9453bc9c1b2b34.woff2";